import React from 'react'
import { Col, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form'
import CustomButton from '../shared/CustomButton';
import { FaSave } from 'react-icons/fa';

const SettingsForm = ({
    setting,
    formAction,
    isSaving
}) => {
    const {
        register,
        handleSubmit,
        formState: {errors},
        setError
    } = useForm({defaultValues: {
            organization_name: setting.organization_name,
            company_logo: setting.company_logo,
            email: setting.email,
            phone: setting.phone,
            geo_fence_radius: setting.geo_fence_radius,
            address: setting.address,
            administrator_email: setting.administrator_email
        }
    });

    const onSubmit = async (data) => {
        const formData = new FormData();

        // Append all text fields 
        Object.keys(data).forEach(key => {
            if (key !== 'company_logo') {
                formData.append(key, data[key]);
            }
        });

        // Append the file if one was selected 
        if (data.company_logo && data.company_logo[0]){
            formData.append('company_logo', data.company_logo[0]);
        }

        try {
            await formAction(formData);
        } catch(error){
            if (error.response && error.response.status === 422) {
                Object.keys(error.response.data.errors).forEach((field) => {
                    setError(field, {
                        type: 'manual',
                        message: error.response.data.errors[field][0]
                    });
                });
            } else {
                throw error; // error will be handled by saveSettings() in Settings.jsx
            }
        }
    }

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>

        <Row>

            <Col xl={3} lg={4} md={6} sm={12}>

                <Form.Group>

                    <Form.Label htmlFor='organization_name'>Organization Name</Form.Label>
                    <input type='text' autoFocus autoComplete='off' placeholder='Organization Name'
                        className={`form-control ${errors.organization_name ? 'is-invalid' : ''}`}
                        {...register('organization_name', {
                            required: 'Enter organization\'s name'
                        })}
                    />
                    {errors.organization_name && (
                        <div className="invalid-feedback">{errors.organization_name.message}</div>
                    )}

                </Form.Group>
            
            </Col>

        </Row>

        <Row>

            <Col xl={3} lg={4} md={6} sm={12}>

                <Form.Group>

                    <Form.Label htmlFor='address'>Address</Form.Label>
                    <textarea autoComplete='off' placeholder='Address'
                        className={`form-control ${errors.address ? 'is-invalid' : ''}`}
                        {...register('address', {
                            required: 'Enter address'
                        })}
                    />
                    {errors.address && (
                        <div className="invalid-feedback">{errors.address.message}</div>
                    )}

                </Form.Group>
            
            </Col>

        </Row>

        <Row>

            <Col xl={3} lg={4} md={6} sm={12}>
                
                <Form.Group>

                    <Form.Label htmlFor='email'>Email Address</Form.Label>
                    <input type='email' autoComplete='off' placeholder='Email Address'
                        className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                        {...register('email', {
                            required: 'Enter organization\'s email address',
                            pattern: {
                                value: /^[A-z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: 'Email address is not valid'
                            }
                        })}
                    />
                    {errors.email && (
                        <div className="invalid-feedback">{errors.email.message}</div>
                    )}

                </Form.Group>

            </Col>
            
        </Row>

        <Row>

            <Col xl={3} lg={4} md={6} sm={12}>

                <Form.Group>

                    <Form.Label htmlFor='phone'>Phone Number</Form.Label>
                    <input type='text' autoComplete='off' placeholder='Phone Number'
                        className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                        {...register('phone', {
                            required: 'Enter organization\'s phone number',
                            pattern: {
                                value: /^\+[0-9]\d{1,14}$/,
                                message: 'Phone number must be in international format'
                            }
                        })}
                    />
                    {errors.phone && (
                        <div className="invalid-feedback">{errors.phone.message}</div>
                    )}

                </Form.Group>
            
            </Col>
            
        </Row>

        <Row>

            <Col xl={3} lg={4} md={6} sm={12}>

                <Form.Group className='mb-3'>

                    <Form.Label htmlFor='company_logo'>Company Logo (PNG)</Form.Label>
                    <input type='file' accept='image/png'
                        className={`form-control ${errors.company_logo ? 'is-invalid' : ''}`}
                        {...register('company_logo', {
                            required: 'Please upload a company logo',
                            validate: {
                                isPng: (files) => 
                                    files[0]?.type === 'image/png' || 'Only PNG files are allowed'
                            }
                        })}
                    />
                    {errors.company_logo && (                        
                        <div className="invalid-feedback">{errors.company_logo.message}</div>
                    )}

                </Form.Group>
            
            </Col>

        </Row>

        <Row>

            <Col xl={3} lg={4} md={6} sm={12}>

                
                <Form.Group>

                    <Form.Label htmlFor='administrator_email'>Administrator Email Address</Form.Label>
                    <input type='email' placeholder='Administrator Email Address' autoComplete='off'
                        className={`form-control ${errors.administrator_email ? 'is-invalid' : ''}`}
                        {...register('administrator_email', {
                            required: 'Enter Administrator\'s email address',
                            pattern: {
                                value: /^[A-z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: 'Email address is not valid'
                            }
                        })}
                    />
                    {errors.administrator_email && (
                        <div className="invalid-feedback">{errors.administrator_email}</div>
                    )}

                </Form.Group>
            
            </Col>

        </Row>

        <CustomButton
            icon={<FaSave />}
            title={isSaving ? 'Saving' : 'Save'}
            isSaving={isSaving}
        />

    </Form>

  )
}

export default SettingsForm
